module.exports = __webpack_public_path__ + "img/4.2ddd6459.jpg";